enum CacheTag {
    WISHLIST = 'wishlist',
    MULTI_PROMOTIONS = 'multiProductPromotions',
}

export { CacheTag };
